class PlatformCourseLearning {
  /**
   * 课程编号
   */
  courseId = ''
  /**
   * 被学习的人次
   */
  learningCount = 0
}

export default PlatformCourseLearning
